import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, orderBy, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase.config';
import AdminNavbar from "./AdminNavbar";
import ProjectCard from '../../components/Admin/ProjectCard';

function AdminProjects() {
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(function() {
        async function fetchProjects() {
            try {
                setLoading(true);
                setError('');
                const projectsRef = collection(db, 'projects');
                const q = query(projectsRef, orderBy('createdAt', 'desc'));
                const snapshot = await getDocs(q);
                const projectsList = snapshot.docs.map(function(doc) {
                    return {
                        id: doc.id,
                        ...doc.data()
                    };
                });
                setProjects(projectsList);
            } catch (err) {
                console.error('Error fetching projects:', err);
                setError('Failed to load projects. Please try again.');
            } finally {
                setLoading(false);
            }
        }

        fetchProjects();
    }, []);

    async function handleDeleteProject(projectId) {
        try {
            await deleteDoc(doc(db, 'projects', projectId));
            setProjects(function(prevProjects) {
                return prevProjects.filter(function(p) {
                    return p.id !== projectId;
                });
            });
        } catch (err) {
            console.error('Error deleting project:', err);
            setError('Failed to delete project. Please try again.');
        }
    }

    return (
        <div className="bg-gray-50">
            <AdminNavbar />
            <div
              className={"min-h-screen w-screen relative z-30 mx-auto px-4 mt-[110px] py-16 pb-36 flex justify-center"}>
                <div className="container">
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-[28px] font-semibold text-[#081542]">BRW Admin Dashboard</h1>
                    </div>

                    <h2 className="text-xl mb-4">Manage Projects</h2>

                    {error && (
                      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                          {error}
                      </div>
                    )}

                    {loading && (
                      <div className="flex justify-center items-center py-12">
                          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#081542]"></div>
                      </div>
                    )}

                    {!loading && !error && projects.length === 0 && (
                      <div className="bg-white p-8 rounded shadow text-center">
                          <p className="text-gray-500 text-lg">No projects available.</p>
                          <p className="text-gray-400 mt-2">
                              Add your first project to get started.
                          </p>
                      </div>
                    )}

                    {!loading && !error && projects.length > 0 && (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                          {projects.map(function (project) {
                              return <ProjectCard key={project.id} project={project} onDelete={handleDeleteProject}/>;
                          })}
                      </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AdminProjects;
